import React, { useState } from "react";
import axios from "axios";
import AiSummaryHeader from "./AiSummaryHeader";
import withStyles from "elevate-ui/withStyles";
import Button from "elevate-ui/Button";

export const AiSummary = ({
  classes,
  listing,
  aiSummary: initAiSummary,
  siteUser,
}) => {
  const [aiSummary, setAiSummary] = useState(
    initAiSummary ? initAiSummary.replace(/\n/g, "<br/>") : ""
  );
  const [isLoading, setIsLoading] = useState(false);

  const fetchAiSummary = async () => {
    setIsLoading(true);
    try {
      const response = await axios.post(
        `/api/ai-listing-summary/${listing.id}`,
        {
          listing,
        }
      );
      setIsLoading(false);
      setAiSummary(response.data);
    } catch (error) {
      setIsLoading(false);
    }
  };

  const handleButtonClick = () => {
    if (!siteUser) {
      // redirect to signup if site user not logged in
      window.location.href = `/ai-signup?redirect=${encodeURIComponent(
        window.location.href
      )}`;
    } else {
      fetchAiSummary(false);
    }
  };

  return (
    <div className={classes.aiSummaryContainer}>
      {aiSummary && (
        <>
          <AiSummaryHeader classes={classes} />
          <br />
        </>
      )}
      {aiSummary &&
        !isLoading && (
          <>
            <div
              className={classes.aiText}
              style={{ whiteSpace: "pre-line", marginLeft: 32 }}
              dangerouslySetInnerHTML={{
                __html: aiSummary.replace(/\n/g, "<br/>"),
              }}
            />
            <div className={classes.aiDisclaimer}>
              Note: The summary is based on the available data. For a more
              detailed understanding, it is advised to refer to the complete
              property listing. Some fields may be insufficiently populated,
              limiting the depth of the summary.
            </div>
          </>
        )}
      {isLoading && <>Loading AI Summary...</>}
      {!aiSummary &&
        !isLoading && (
          <Button onClick={handleButtonClick}> Generate AI Summary</Button>
        )}
    </div>
  );
};

const styles = (theme) => ({
  aiSummaryContainer: {
    padding: "16px",
    borderRadius: "2px",
    border: `1px solid ${theme.colors.gray["200"]}`,
  },
  aiText: {
    whiteSpace: "pre-line",
    marginLeft: 32,
  },
  aiDisclaimer: {
    marginLeft: 32,
    marginTop: 32,
    fontStyle: "italic",
  },
});

export default withStyles(styles)(AiSummary);
